import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { GetWebCommonConfigMeta } from '@whelk/services/src/type/chat';

// 前端爬取所需要的信息，包含正则匹配url的规则，爬取文件的限制等等
const initialState = {
  regexp: '' as GetWebCommonConfigMeta['regexp_url'],
  preloadUrlConfig: {} as GetWebCommonConfigMeta['preload_url_config'],
};

export const spiderSlice = createSlice({
  name: 'spider',
  initialState,
  reducers: {
    setRegexp: (state, action: PayloadAction<GetWebCommonConfigMeta['regexp_url']>) => {
      state.regexp = action.payload;
    },
    setPreloadUrlConfig: (
      state,
      action: PayloadAction<GetWebCommonConfigMeta['preload_url_config']>,
    ) => {
      state.preloadUrlConfig = action.payload;
    },
  },
});

export const { setRegexp, setPreloadUrlConfig } = spiderSlice.actions;

export default spiderSlice.reducer;
